<template>
<v-flex class="accountStatements" data-qa="accountstatements-flex-sads3i">
    <v-layout wrap class="ml-2 accountStatements--gradientBGposition" data-qa="accountstatements-layout-cftpqm">
      <v-flex
        xs12
        sm12
        md12
        lg12
        xl12
        :style="{ background: dashboardGradient, height: '180px' }"
       data-qa="accountstatements-flex-vd4whf">
        <v-container class="accountStatements--title-padding" data-qa="accountstatements-container-l2r7g2">
          <v-flex xs12 sm12 md12 lg12 xl12 data-qa="accountstatements-flex-knf21o">
            <v-row no-gutters data-qa="accountstatements-row-rmwocv">
              <v-layout row wrap class="pb-2 pl-12" data-qa="accountstatements-layout-tlw0cc">
                    <div class="pt-3" data-qa="accountstatements-div-sqii0m">
                    <v-avatar :tile="false" size="35" color="white" data-qa="accountstatements-avatar-d7t34">
                      <v-icon :color="primaryColor" data-qa="accountstatements-icon-mwwoxr">mdi-file-document</v-icon>
                    </v-avatar>
                    </div>
                <v-flex xs9 sm9 md9 lg9 xl9 class="pt-4 pl-2" data-qa="accountstatements-flex-wkgov">
                  <v-row no-gutters data-qa="accountstatements-row-4ayjvs">
                    <font class="text-h5 font-weight-light white--text">
                      {{ $t("accountStatements.title")}}</font
                    >
                  </v-row>
                </v-flex>
              </v-layout>
            </v-row>
          </v-flex>
        </v-container>
        <!-- </v-layout> -->
      </v-flex>
    </v-layout>
    <v-flex xs12 sm12 md12 lg10 xl10 class="accountStatements--content-padding accountStatements--overlayCardFlex" data-qa="accountstatements-flex-0dq498">
      <v-layout row wrap class="accountStatements--content-padding" data-qa="accountstatements-layout-ncjkh">
        <v-flex xs12 sm11 md10 lg9 xl10 class="pt-4" data-qa="accountstatements-flex-y7c3">
          <v-card data-qa="accountstatements-card-92nvxm">
            <v-container  data-qa="accountstatements-container-t3krf">
        <v-layout class="hidden-md-and-down" data-qa="accountstatements-layout-dfbyo1">
        <v-flex xs12 sm6 md6 lg8 xl6 data-qa="accountstatements-flex-32aa2j">
          <v-autocomplete
            data-qa="accountType"
            v-model="selectedAccountType"
            :items="accountTypes"
            :color="primaryColor"
            @change="getAccountList(selectedAccountType)"
            append-icon="mdi-chevron-down"
            filled
            background-color="#f0eff7"
            :label="$t('accountStatements.label.accountType')"
            class="pt-4 pl-2"
          >
            <template v-slot:no-data>
              <v-list-item-content class="pl-3" data-qa="accountstatements-list-item-content-m8e5zl">
                {{ $t('accountStatements.noDataAvailable') }}
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 sm6 md6 lg8 xl6 data-qa="accountstatements-flex-7zyqf">
          <v-autocomplete
            data-qa="accountNumber"
            v-model="accountNumber"
            :items="accountList"
            :color="primaryColor"
            append-icon="mdi-chevron-down"
            filled
            :disabled="!selectedAccountType"
            background-color="#f0eff7"
            :label="$t('accountStatements.label.accountNumber')"
            class="pt-4 pl-2"
          >
            <template v-slot:no-data>
              <v-list-item-content class="pl-3" data-qa="accountstatements-list-item-content-fxey0g">{{ $t('accountStatements.noDataAvailable') }}</v-list-item-content>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 sm6 md6 lg8 xl6 data-qa="accountstatements-flex-xt4gqa">
          <v-autocomplete
            data-qa="statementType"
            v-model="statementType"
            :items="statementTypeList"
            :color="primaryColor"
            :disabled="accountNumber && selectedAccountType ? false : true"
            append-icon="mdi-chevron-down"
            filled
            background-color="#f0eff7"
            :label="$t('accountStatements.label.statementType')"
            class="pt-4 pl-2"
          >
            <template v-slot:no-data>
              <v-list-item-content class="pl-3" data-qa="accountstatements-list-item-content-3thckw">{{ $t('accountStatements.noDataAvailable') }}</v-list-item-content>
            </template>
          </v-autocomplete>
        </v-flex>
        </v-layout>
        <v-flex xs12 sm6 md6 lg12 xl6 class="pt-0 pl-2 pb-3 text-end hidden-md-and-down" style="margin-top:-20px" data-qa="accountstatements-flex-ryv7b5">
          <v-btn
            data-qa="showStatementBtn"
            :color="primaryColor"
            :disabled="statementType && accountNumber && selectedAccountType ? false : true"
            class="white--text text-none py-2 px-4"
            @click="getListOfAccountStatements (statementType)"
          >{{$t('accountStatements.button.showStatements')}}</v-btn>
        </v-flex>

        <v-flex class="hidden-lg-and-up" data-qa="accountstatements-flex-cb0mp7">
        <v-flex xs12 sm12 md12 lg8 xl6 data-qa="accountstatements-flex-6emmbo">
          <v-autocomplete
            data-qa="accountType"
            v-model="selectedAccountType"
            :items="accountTypes"
            :color="primaryColor"
            @change="getAccountList(selectedAccountType)"
            append-icon="mdi-chevron-down"
            filled
            background-color="#f0eff7"
            :label="$t('accountStatements.label.accountType')"
            class="pt-0 pl-2"
          >
            <template v-slot:no-data>
              <v-list-item-content class="pl-3" data-qa="accountstatements-list-item-content-r6cfpl">{{ $t('accountStatements.noDataAvailable') }}</v-list-item-content>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 sm12 md12 lg8 xl6 data-qa="accountstatements-flex-7v6dw">
          <v-autocomplete
            data-qa="accountNumber"
            v-model="accountNumber"
            :items="accountList"
            :color="primaryColor"
            append-icon="mdi-chevron-down"
            filled
            :disabled="!selectedAccountType"
            background-color="#f0eff7"
            :label="$t('accountStatements.label.accountNumber')"
            class="pt-0 pl-2"
          >
            <template v-slot:no-data>
              <v-list-item-content class="pl-3" data-qa="accountstatements-list-item-content-hqqq2a">{{ $t('accountStatements.noDataAvailable') }}</v-list-item-content>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 sm12 md12 lg8 xl6 data-qa="accountstatements-flex-iduy8l">
          <v-autocomplete
            data-qa="statementType"
            v-model="statementType"
            :items="statementTypeList"
            :color="primaryColor"
            :disabled="accountNumber && selectedAccountType ? false : true"
            append-icon="mdi-chevron-down"
            filled
            background-color="#f0eff7"
            :label="$t('accountStatements.label.statementType')"
            class="pt-0 pl-2"
          >
            <template v-slot:no-data>
              <v-list-item-content class="pl-3" data-qa="accountstatements-list-item-content-k1hl8s">{{ $t('accountStatements.noDataAvailable') }}</v-list-item-content>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 sm12 md6 lg6 xl6 class="pt-0 pl-2" data-qa="accountstatements-flex-aro5gd">
          <v-btn
            data-qa="showStatementBtn"
            :color="primaryColor"
            :disabled="statementType && accountNumber && selectedAccountType ? false : true"
            class="white--text text-none py-2 px-4"
            @click="getListOfAccountStatements (statementType)"
          >{{$t('accountStatements.button.showStatements')}}</v-btn>
        </v-flex>
                </v-flex>
                <v-divider data-qa="accountstatements-divider-rpkyf2"  v-if="eStatementList.length" class="pa-1" />
              <!-- List the statements -->
              <v-list v-if="eStatementList.length" class="px-5" data-qa="accountstatements-list-t6gpht">
                <v-list-item-content
                  v-for="(statement, index) in eStatementList"
                  :key="index"
                  :data-qa="`accountstatements-list-item-content-jj5l7-${index}`">
                  <v-card-text class="pa-2" :data-qa="`accountstatements-card-text-10zbhl-${index}`">
                    <v-layout wrap :data-qa="`accountstatements-layout-yczvwf-${index}`">
                      <v-flex xs12 sm12 md12 lg7 xl7 :data-qa="`accountstatements-flex-gp479p-${index}`">
                        <span
                          class="body-1 font-weight-regular"
                          v-text="statement.data"
                          :data-qa="`accountstatements-span-z8jboh9-${index}`"></span>
                      </v-flex>
                      <v-flex xs12 sm12 md12 lg5 xl5 :data-qa="`accountstatements-flex-b77cac-${index}`">
                        <v-btn
                          @click="downloadStatement('view', statement.documentId, statementType)"
                          text
                          :color="primaryColor"
                          :data-qa="`accountstatements-btn-lc54ng-${index}`">
                          <v-icon left size="18px" class="material-symbols-outlined" :data-qa="`accountstatements-icon-qyp5rl-${index}`">visibility</v-icon>
                          <font class="body-2 font-weight-regular">
                          {{
                            $t("consolidatedStatement.viewBtn")
                          }}</font>
                        </v-btn>
                        <v-btn
                          @click="downloadStatement('download', statement.documentId, statementType)"
                          text
                          :color="primaryColor"
                          :data-qa="`accountstatements-btn-do83un-${index}`">
                          <v-icon left size="18px" class="material-symbols-outlined" :data-qa="`accountstatements-icon-gmg2qj-${index}`">download</v-icon>
                          <font class="body-2 font-weight-regular">{{
                            $t("consolidatedStatement.downloadBtn")
                          }}</font>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-divider :data-qa="`accountstatements-divider-tttfo7-${index}`"  v-if="!(index === eStatementList.length - 1)" />
                </v-list-item-content>
              </v-list>
              <v-flex v-if="eStatementList.length" xs12 sm12 md8 lg9 xl8 class="pl-4" data-qa="accountstatements-flex-9nsoyp">
              <v-alert
                  icon="mdi-information-outline" class="v-alert--info"
                  data-qa="accountstatements-alert-86tres">
                  <span class="body-2 font-weight-bold" data-qa="accountstatements-span-qqwjek">{{ $t("accountStatements.note") }}</span>
                  <span class="body-2 font-weight-regular" data-qa="accountstatements-span-4korgc">
                    {{ $t("accountStatements.info") }}
                  </span>
              </v-alert>
              </v-flex>
              <v-row v-if="(!eStatementList.length && (noStatementsAvail || noIntrestStatementsAvailable)) || (!eStatementList.length && noStatementFound)" no-gutters justify="center" class="ma-6 ml-0" data-qa="accountstatements-row-1krv68m">
                <div outlined class="text-center pa-6" color="#FAFAFA" data-qa="accountstatements-div-fkdpgf">
                <v-icon x-large :color="primaryColor" class="pb-3" data-qa="accountstatements-icon-5k055h">mdi-file-document</v-icon>
                  <p v-if="noStatementsAvail" :class="{'ma-6 mt-0 px-12': !$vuetify.breakpoint.smAndDown }" data-qa="accountstatements-p-t3ymf7">
                    {{ $t("accountStatements.noStatementsAvailable") }}
                  </p>
                  <p v-if="noStatementFound" :class="{'ma-6 mt-0 px-12': !$vuetify.breakpoint.smAndDown }" data-qa="accountstatements-p-h2cyjt">
                    {{ $t("accountStatements.noStatementFound") }}
                  </p>
                  <p v-if="noIntrestStatementsAvailable" :class="{'ma-6 mt-0 px-12': !$vuetify.breakpoint.smAndDown }" data-qa="accountstatements-p-h02fvh">
                    {{ $t("accountStatements.noIntrestStatementsAvailable") }}
                  </p>
                </div>
              </v-row>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
  <!-- Doc preview -->
  <PDFPreview v-if="viewPDF" :PDFData="PDFData" @closePdfPreview="viewPDF= false"/>
</v-flex>
</template>
<script>
import '@/styles/pages/accountStatements.scss'
import store from '@/core/store'
import _ from 'lodash'
import preload from '@/util/preload'
import CommonService from '@/service/commonService.js'
import PDFPreview from '@/components/common/PDFPreview.vue'

export default {
  name: 'AccountStatements',
  components: {
    PDFPreview
  },
  data () {
    return {
      selectedAccountType: '',
      accountTypesList: this.$appSettings.defaultConfigurations.accountStatements,
      accountTypes: [],
      accountNumber: '',
      accountList: [],
      casaAccounts: '',
      statementType: '',
      statementTypeList: this.$appSettings.defaultConfigurations.statementTypeList,
      toDate: new Date().toISOString().substr(0, 10),
      fromDate: '',
      eStatementList: [],
      generatedStatementType: '',
      generatedAccountId: '',
      tdAccounts: '',
      noStatementsAvail: true,
      noIntrestStatementsAvailable: false,
      noStatementFound: false,
      statementDoc: undefined,
      viewPDF: false,
      PDFData: undefined,
      showSavingAccountType: false,
      showCurrentAccountType: false,
      showLoanAccountType: false,
      showDepositAccountType: false,
      isSmeLogin: JSON.parse(sessionStorage.getItem('isSmeLogin')),
      permissions: [],
      enabledAccountType: {},
      accountTypesPermissions: {
        Saving: 'SAVING_VIEW_AND_DOWNLOAD_STATEMENTS',
        Current: 'CURRENT_VIEW_AND_DOWNLOAD_STATEMENTS',
        Loan: 'LOAN_VIEW_AND_DOWNLOAD_STATEMENTS',
        Deposit: 'DEPOSITS_VIEW_DETAILS'
      },
      excludeAccountType: [],
      enableRoleBasedAccess: this.$appSettings.defaultConfigurations.smeRoles.enableRoleBasedAccess
    }
  },
  async created () {
    this.fromDate = new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toISOString().substr(0, 10)
    if (this.isSmeLogin && this.enableRoleBasedAccess) {
      this.permissions = store.getters['profileStore/profileData']?.permissions
      this.enabledAccountType = store.getters['profileStore/profileData']?.enabledAccountType
    }
    if (store.getters['userStore/userData'].myAccounts) {
      this.casaAccounts = store.getters['userStore/userData'].myAccounts
    } else {
      await preload.getListOfAccounts(JSON.parse(sessionStorage.getItem('username')))
    }
    if (store.getters['userStore/userData'].loanAccounts) {
      this.loanAccounts = store.getters['userStore/userData'].loanAccounts
    } else {
      await preload.getListOfLoanAccounts(JSON.parse(sessionStorage.getItem('username')))
    }
    await this.checkAccountTypeAllowed()
    this.showAccountTypes()
  },
  methods: {
    async checkAccountTypeAllowed () {
      this.showSavingAccountType = (this.isSmeLogin && this.enableRoleBasedAccess)
        ? this.enabledAccountType?.saving 
          ? (this.permissions?.includes('SAVING_VIEW_DETAILS') &&  this.permissions?.includes('SAVING_VIEW_AND_DOWNLOAD_STATEMENTS'))
          : false
        : true
      this.showCurrentAccountType = (this.isSmeLogin && this.enableRoleBasedAccess)
        ? this.enabledAccountType?.current
          ? (this.permissions?.includes('CURRENT_VIEW_DETAILS') && this.permissions?.includes('CURRENT_VIEW_AND_DOWNLOAD_STATEMENTS'))
          : false
        : true
      this.showLoanAccountType = (this.isSmeLogin && this.enableRoleBasedAccess)
        ? this.enabledAccountType?.loan
          ? (this.permissions?.includes('LOAN_VIEW_DETAILS') &&  this.permissions?.includes('LOAN_VIEW_AND_DOWNLOAD_STATEMENTS'))
          : false
        : true
      this.showDepositAccountType = (this.isSmeLogin && this.enableRoleBasedAccess)
        ? this.enabledAccountType?.deposit
          ? (this.permissions?.includes('DEPOSITS_VIEW_DETAILS'))
          : false
        : true

        if (!this.showSavingAccountType) {
          this.excludeAccountType.push('SVGS')
        }
        if (!this.showCurrentAccountType) {
          this.excludeAccountType.push('CACC')
        }
        if (!this.showLoanAccountType) {
          this.excludeAccountType.push('Loan')
        }
        if (!this.showDepositAccountType) {
          this.excludeAccountType.push('TD')
        }
    },
    resetFieldsAndTexts () {
      /** When Account type / account number is changed, reset the account number and statement type field also reset the texts */
      this.statementType = ''
      this.accountNumber = ''
      this.noStatementsAvail = true
      this.noStatementFound = false
      this.noIntrestStatementsAvailable = false
      this.eStatementList = []
    },
    async getAccountList (accountType) {
      this.resetFieldsAndTexts()
      switch (accountType) {
        case 'SVGS':
          this.accountList = []
          this.accountNumber = ''
          this.casaAccounts = store.getters['userStore/userData'].myAccounts
          this.casaAccounts = this.casaAccounts && this.casaAccounts.savingAccounts ? this.casaAccounts.savingAccounts.accountList : []
          if (this.casaAccounts.length) {
            this.casaAccounts = _.filter(this.casaAccounts, account => { return !(this.$appSettings.uiFieldsDisplayConfigurations.casaAccountListing.exclusionList.includes(account.accountStatus)) })
          }
          this.casaAccounts.forEach(key => {
            this.accountList.push({
              text: this.$t('common.savingsTypeLabel') + ' ' + '-' + ' ' + key.accountId,
              value: key.accountId
            })
          })
          break
        case 'CACC':
          this.accountList = []
          this.accountNumber = ''
          this.casaAccounts = store.getters['userStore/userData'].myAccounts
          this.casaAccounts = this.casaAccounts && this.casaAccounts.currentAccounts ? this.casaAccounts.currentAccounts.accountList : []
          if (this.casaAccounts.length) {
            this.casaAccounts = _.filter(this.casaAccounts, account => { return !(this.$appSettings.uiFieldsDisplayConfigurations.casaAccountListing.exclusionList.includes(account.accountStatus)) })
          }
          this.casaAccounts.forEach(key => {
            this.accountList.push({
              text: this.$t('common.currentTypeLabel') + ' ' + '-' + ' ' + key.accountId,
              value: key.accountId
            })
          })
          break
        case 'Loan':
          this.accountList = []
          this.loanAccounts = store.getters['userStore/userData'].loanAccounts
          this.loanAccounts.forEach(key => {
            this.accountList.push({
              text: this.$t('common.loanLabel') + ' ' + '-' + ' ' + key.loanId,
              value: key.loanId
            })
          })
          break
        case 'TD':
          this.accountList = []
          this.tdAccounts = store.getters['userStore/userData'].myAccounts.deposits.accountList
          this.tdAccounts.forEach(key => {
            this.accountList.push({
              text: this.$t('accountStatements.depositTypeLabel') + ' ' + '-' + ' ' + key.fixedDepositAccountId,
              value: key.fixedDepositAccountId  
            })
          })
      }
      this.updateStatementTypes(accountType)
    },
    showAccountTypes () {
      this.accountTypes = []
      Object.entries(this.accountTypesList).forEach(([key, val]) => {
      if ((this.isSmeLogin && this.enableRoleBasedAccess) ? !this.excludeAccountType.includes(val.value) : true) {
        this.accountTypes.push({
          text: this.$t(val.text),
          value: val.value
        })
      }
      })
    },
    async getListOfAccountStatements (statementType) {
      this.generatedAccountId = this.accountNumber
      const details = {
        businessType: 'ACCOUNT',
        businessValue: this.accountNumber
      }
      if (statementType === 'Account Statements') {
        details.docType = this.selectedAccountType === 'Loan' ? 'LOAN-STATEMENT' : 'CASA'
        details.fromDate = this.fromDate
        details.toDate = this.toDate
      } else {
        details.docType = 'INTEREST-STATEMENT'
      }
      const response = await CommonService.getListOfAccDocStatements(details)
      this.generatedStatementType = statementType
      if (response && response.items) {
        this.noStatementsAvail = false
        this.eStatementList = []
        response.items.forEach((item) => {
          if (statementType !== 'Account Statements') {
            const dateValue = new Date(item.generationDate)
            const toDate = dateValue.getFullYear()
            const fromDate = toDate - 1
            this.eStatementList.push({
              data: `FY ${fromDate}-${toDate}`,
              documentId: item.documentId
            })
          } else {
            const fromDate = this.$formatter.formatDate(item.fromDate)
            const toDate = this.$formatter.formatDate(item.toDate)
            this.eStatementList.push({
              data: `${fromDate} to ${toDate}`,
              documentId: item.documentId
            })
          }
        })
      } else {
        this.eStatementList = []
        if (this.generatedStatementType === 'Interest Statements') {
          this.noIntrestStatementsAvailable = true
          this.noStatementFound = false
          this.noStatementsAvail = false
        } else {
          this.noStatementFound = true
          this.noStatementsAvail = false
          this.noIntrestStatementsAvailable = false
        }
      }
      // this.loaderEnabled = false
    },
    async downloadStatement (type, documentId, statementType) {
      const body = {
        businessType: 'ACCOUNT',
        businessValue: this.accountNumber,
        docType: statementType === 'Account Statements' ? (this.selectedAccountType === 'Loan' ? 'LOAN-STATEMENT' : 'CASA') : 'INTEREST-STATEMENT'
      }
      const response = await CommonService.downloadStatement(documentId, body)

      if (response && !response.causes) {
        const userLoginId = sessionStorage.getItem('userId')
          ? JSON.parse(sessionStorage.getItem('userId'))
          : JSON.parse(sessionStorage.getItem('username'))
        let fileName = `E-Statement-${userLoginId}.pdf`
        if (this.generatedStatementType === 'Interest Statements') {
          fileName = `Interest-Statement-${this.generatedAccountId}.pdf`
        }
        // const blobObject = new Blob([response], { type: 'application/pdf' })
        // const fileURL = window.URL.createObjectURL(blobObject)
        if (type === 'view') {
          this.PDFData = response
          this.viewPDF = true
        } else {
          if (response && !response.causes) { // positive response
            // this.downloadFile(fileURL, fileName)
            var a = document.createElement('a') // Create <a data-qa="accountstatements-a-i6ja7si">
            a.href = response // Image Base64 Goes here
            a.download = fileName
            a.click()
          }
        }
      }
    },
    downloadFile (file, fileName) {
      var link = document.createElement('a')
      link.href = file
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    async updateStatementTypes (accountType) {
      this.statementTypeList = {}
      if (accountType === 'SVGS' || accountType === 'CACC') {
        this.statementTypeList = [{ text: this.$t('common.accountStmtntLabel'), value: 'Account Statements' }, { text: this.$t('common.intrstStatmentLabel'), value: 'Interest Statements' }]
      } else if (accountType === 'Loan') {
        this.statementTypeList = [{ text: this.$t('common.accountStmtntLabel'), value: 'Account Statements' }]
      } else if (accountType === 'TD') {
        this.statementTypeList = [{ text: this.$t('common.intrstStatmentLabel'), value: 'Interest Statements' }]
      } else {
        this.statementTypeList = [{ text: this.$t('common.accountStmtntLabel'), value: 'Account Statements' }, { text: this.$t('common.intrstStatmentLabel'), value: 'Interest Statements' }]
      }
      return this.statementTypeList
    }
  }
}
</script>
